const NoResultsFound = ({ message = 'No results were found' }) => {
  return (
    <div className="text-center text-3xl">
      <i className="icon-no-results text-100" />
      <p className="mt-3">{message} </p>
    </div>
  )
}

export default NoResultsFound;